<template>
    <transition mode="out-in" name="fade">
        <div class="container-fluid touch-page view" v-if="show">
            <div class="line100">
                <div class="dflex">
                    <router-link class="btn btn-big" to="/leagues">Back</router-link>
                    <div><h1>League</h1>
                    <h2>{{name}}</h2></div>
                    <router-link class="btn btn-big" to="/">Home Page</router-link>
                </div>

            </div>
            <div class="inline100">
                <app-table :table="table"></app-table>
                <div class="clear"></div>
                <transition name="slide-fade" mode="out-in">
                <div class="go_to_round_div">Go to Round:
                    <ul class="go_to_round">
                        <transition-group name="slide-fade">
                            <li :key="r" v-for="r in maxRounds">
                                <a @click="animate(r)">{{r}}</a>
                            </li>
                        </transition-group>
                    </ul>
                </div>
                </transition>
                <div class="clear"></div>
                <app-rounds :rounds="rounds" :special="special" ></app-rounds>
                <transition mode="out-in" name="fade">
                <a id="js-btn-pageTop" class="btn-pageTop" @click="goToTop" v-if="showGoToTop">
                    <img class="img-fluid" src="/static/img/arrow-up.png"></a>
                </transition>
            </div>
        </div>
        <div v-else>
            <div class="loader" id="loader-1"></div>
        </div>
    </transition>
</template>
<script>
    import axios from 'axios'
    import Table from './Table.vue';
    import Rounds from './Rounds.vue';

    export default{
        props:['id'],
        components: {
            'app-table': Table,
            'app-rounds': Rounds
        },
        data(){
            return{
                table: null,
                rounds:null,
                maxRounds:null,
                special:null,
                name:null,
                currentRoute: window.location.pathname,
                show: false,
                showGoToTop: false
            }
        },
        mounted (){
            axios.get('/ajax.php?q=getLeagueView&id='+this.id)
                    .then(res => {
                this.table = res.data.table;
                this.rounds = res.data.rounds.matches;
                this.maxRounds = res.data.rounds.maxRounds;
                this.special = res.data.rounds.special;
                this.name = res.data.name;
                this.show = true;
            })
        .catch(error => console.log(error))
        },
        methods: {
            animate(el){
                window.scrollTo({
                    top:document.getElementById('round_' + el).offsetTop,
                    behavior: 'smooth'
                })
            },
            goToTop(){
                window.scrollTo({
                    top:0,
                    behavior: 'smooth'
                })
                this.showGoToTop = false;
            },
            handleScroll(event){
                this.showGoToTop = true;
            }
        },
        created () {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Leagues/View.vue